"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_UPLOAD = void 0;
exports.API_UPLOAD = process
    && process.env
    && process.env.REACT_APP_API_MAESTRO_FILE_UPLOAD
    ? process.env.REACT_APP_API_MAESTRO_FILE_UPLOAD
    : 'https://apigateway.integration.misp-solutions.com/maestro-uploads';
if (!process.env.REACT_APP_API_MAESTRO_FILE_UPLOAD) {
    console.log("\n  You should setup REACT_APP_API_MAESTRO_FILE_UPLOAD\n  now you are using the default one :\n  https://apigateway.integration.misp-solutions.com/maestro-uploads\n ");
}
//# sourceMappingURL=enviroment.vars.js.map